// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__7C37E","container":"Modal_container__rpKE3","innercontainer":"Modal_innercontainer__lMaSt","component":"Modal_component__28UaU"};